import React from "react";
import { Text } from "@aws-amplify/ui-react";

export function SubscriptionPlans() {
  return <Text>SubscriptionPlans</Text>;
}
